import cx from 'classnames';

import styles from './LiveSaleIndicator.module.scss';

type LiveSaleIndicatorProps = {
  size?: 'default' | 'small';
};

export const LiveSaleIndicator = ({ size = 'default' }: LiveSaleIndicatorProps) => (
  <span
    aria-hidden="true"
    className={cx(styles.component, { [styles.small]: size === 'small' })}
  />
);
